class ProductDetailsTabs {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-pdt-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-pdt-panel]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  activate(tab) {
    const index = tab.getAttribute('data-index');

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === `pdt-panel-${this.root.id.replace('pdt-', '')}-${index}`;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    tab.focus();
  }

  onKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let newIndex = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        newIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(this.tabs[newIndex]);
  }
}

function initProductDetailsTabs() {
  document.querySelectorAll('[data-pdt]').forEach((root) => {
    if (root.dataset.pdtInitialized) return;
    root.dataset.pdtInitialized = 'true';
    new ProductDetailsTabs(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductDetailsTabs);
} else {
  initProductDetailsTabs();
}

document.addEventListener('shopify:section:load', initProductDetailsTabs);
